// extracted by mini-css-extract-plugin
export default {"modal-container":"bmp-modal_modal-container__89LEX","close-btn":"bmp-modal_close-btn__b45CI","tableActions":"bmp-modal_tableActions__wYfrm"};